import React from "react";
import "./Hero.css";
import { Link } from "react-router-dom";
import walletHeroBanner from "../../assets/images/IZB/IZB Website Skin/Home_Page/Indo-Wallet-Hero-Banner.png";

const HeroSlide8 = () => {
  return (
    <Link to="/WalletBanking">
      <img src={walletHeroBanner} alt="hero-banner-desktop" className="hide-on-mobile home-hero-banner" />
      <img src={walletHeroBanner} alt="hero-banner-mobile" className="hide-on-desktop home-hero-banner" />
    </Link>
  );
};

export default HeroSlide8;
